{
	"name": "@whop/cli",
	"version": "0.10.0",
	"description": "The Whop CLI — build and manage Whop apps from your terminal. Human and agent friendly.",
	"keywords": [
		"agent",
		"apps",
		"cli",
		"developer",
		"whop"
	],
	"homepage": "https://whop.com/developers/",
	"bugs": "https://github.com/whopio/whop-public-cli/issues",
	"license": "MIT",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/whopio/whop-public-cli.git"
	},
	"bin": {
		"whop": "dist/index.js",
		"whop-cli": "dist/index.js"
	},
	"files": [
		"dist",
		"skills"
	],
	"type": "module",
	"exports": {
		".": "./dist/index.js",
		"./vite": {
			"types": "./dist/vite.d.ts",
			"import": "./dist/vite.js"
		}
	},
	"publishConfig": {
		"access": "public"
	},
	"scripts": {
		"build": "tsx scripts/sync-spec.ts && pnpm run clean && tsup",
		"build:binary": "tsx scripts/build-binary.ts",
		"clean": "rm -rf dist",
		"dev": "tsx scripts/sync-spec.ts && tsx src/index.ts",
		"start": "node dist/index.js",
		"check-types": "tsx scripts/sync-spec.ts && tsc --noEmit",
		"lint": "oxlint .",
		"lint:fix": "oxlint --fix --fix-suggestions && oxfmt",
		"ci:lint": "oxlint -f github .",
		"format": "oxfmt",
		"sync-spec": "tsx scripts/sync-spec.ts",
		"test": "tsx --test scripts/*.test.ts"
	},
	"dependencies": {
		"@clack/prompts": "^1.5.1",
		"@napi-rs/keyring": "^1.3.0",
		"@whop/sdk": "^0.0.40",
		"chalk": "5.4.1",
		"yaml": "2.8.0"
	},
	"devDependencies": {
		"@types/node": "25.3.5",
		"fflate": "0.8.2",
		"incur": "github:whopio/incur#9e4339e90ed46153268c0183d5f49245598bed57",
		"tsup": "8.5.0",
		"tsx": "4.19.4",
		"typescript": "5.9.3",
		"vite": "7.3.6"
	},
	"engines": {
		"node": ">=22"
	},
	"packageManager": "pnpm@10.23.0"
}
